module.exports = __webpack_public_path__ + "img/bg_checkbox_active.d8a29fd4.svg";